<template>
  <CrudFilter :has-filters="hasFilters" :loading-search="loadingBTN" :loading-clear="loadingTrashButton" @search="search" @clear="clearFields">
    <v-list-item>
      <v-text-field
        color="#086318"
        label="Unidade"
        class="rounded-lg"
        hide-details
        outlined
        dense
        v-model="unitySearch.hospital"
      />
    </v-list-item>
    <v-list-item>
      <v-text-field
        color="#086318"
        label="Município"
        class="rounded-lg"
        hide-details
        outlined
        dense
        v-model="unitySearch.municipality"
      />
    </v-list-item>
    <v-list-item>
      <v-text-field
        color="#086318"
        label="CNES"
        outlined
        class="rounded-lg"
        v-model="unitySearch.cnes"
        maxlength="7"
        hide-details
        dense
      />
    </v-list-item>
    <v-list-item>
      <v-autocomplete
        :items="orgons"
        label="Orgãos"
        class="rounded-lg"
        hide-details
        color="#086318"
        v-model="unitySearch.orgon_name"
        item-value="name"
        item-text="name"
        dense
        outlined
      />
    </v-list-item>
  </CrudFilter>
</template>

<script>
import CrudFilter from "../widgets/Filter.vue";
import { getUnities, getAllOrgons } from "@/service/basic-registrations/UnitiesService";

export default {
  components: { CrudFilter },

  data() {
    return {
      loadingBTN: false,
      loadingTrashButton: false,
      unitySearch: {},
      orgons: [],
      options: {
        page: 0,
        itemsPerPage: 10,
        sortBy: ["name"],
        sortDesc: [false],
      },
    };
  },

  computed: {
    hasFilters() {
      return Object.values(this.unitySearch || {}).some(v => v != null && v !== '');
    },
  },

  async mounted() {
    this.getOrgons();

    const savedSearch = sessionStorage.getItem('unitySearchFilter');
    if (savedSearch) {
      this.unitySearch = JSON.parse(savedSearch);
      this.search();
    }
  },

  methods: {
    async search() {
      this.loadingBTN = true;
      const { page, itemsPerPage } = this.options;

      sessionStorage.setItem('unitySearchFilter', JSON.stringify(this.unitySearch));

      const result = await getUnities({
        hospital: this.unitySearch.hospital,
        municipality: this.unitySearch.municipality,
        cnes: this.unitySearch.cnes,
        orgon_name: this.unitySearch.orgon_name,
        page,
        per_page: itemsPerPage,
      });

      this.$emit('resource', result.data);
      this.loadingBTN = false;
    },

    getOrgons() {
      getAllOrgons().then((result) => {
        this.orgons = result;
      });
    },

    clearFields() {
      this.loadingTrashButton = true;
      this.unitySearch = {};
      sessionStorage.removeItem('unitySearchFilter');
      setTimeout(() => {
        this.loadingTrashButton = false;
        this.search();
      }, 1000);
    },
  },
};
</script>
